import { JwtHelperService } from "@auth0/angular-jwt";

type DecodedToken = {
  sub: string;
  timeTrocaSenha: string;
  idPerfisAcesso: unknown[];
  idUsuarioMaster: string | null;
  userIdZemt: number;
  id: number;
  user: string;
  companyId: string;
  employeeId: string;
  iat: number;
  exp: number;
};


type UserInfo = {
  id: number;
  email: string;
};

export default function decodeToken(token: string): UserInfo | null {
  if (!token) return null;

  try {
    const helper = new JwtHelperService();
    const decoded = helper.decodeToken<DecodedToken>(token);

    if (!decoded) return null;

    return {
      id: decoded.id,
      email: decoded.user
    };
  } catch {
    return null;
  }
}
